/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * Meeting BaaS API
 * OpenAPI spec version: 1.1
 */

/**
 * Recording mode for the bot
 */
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordingMode = {
  speaker_view: "speaker_view",
  gallery_view: "gallery_view",
  audio_only: "audio_only"
} as const
export type RecordingMode = (typeof RecordingMode)[keyof typeof RecordingMode]
